require('./styles/critical.less')
require('./styles/main.less')

require('./js/nav-scroll.js')
require('./js/nav.js')
require('./js/tab-handler.js')
require('./js/parallax.js')
require('./js/swiper.js')
require('./js/filter-fuzzy.js')
require('./js/emergency.js')

import Vue from 'vue'
import 'document-register-element/build/document-register-element'; // pollyfill-for custom element in ie9+
import CE from 'vue-custom-element'
import SvgIcon from './js/SvgIcon.vue.js'
import SubmitEvent from './vue/SubmitEvent.vue'
import Bananar from '../bananar/Bananar.vue'
import LLC from '../bananar/LLC.vue'

Vue.use(CE)
Vue.customElement('svg-icon', SvgIcon)
Vue.customElement('submit-event', SubmitEvent)
Vue.customElement('banana-r', Bananar)
Vue.customElement('llc-banana-r', LLC)

export default {
  Vue
}



// WEBPACK FOOTER //
// ./theme/_base/index.js